module.exports = __webpack_public_path__ + "img/ai_exchange.2aad6b48.svg";